import React, { useEffect, useState } from "react";
import "../assets/css/--component-scroll-to-top.css";

const SHOW_AT_SCROLL_Y = 400;

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > SHOW_AT_SCROLL_Y);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button className="scroll-to-top-btn" onClick={scrollToTop} type="button" aria-label="Back to top">
      <i className="ri-arrow-up-line"></i>
    </button>
  );
};

export default ScrollToTop;
